import React from 'react';

const MONTHS = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez'
];

const XPItem = ({
  initialMonth,
  finalMonth,
  initialYear,
  finalYear,
  companyName,
  jobPosition,
  isCurrent
}) => {
  const initialDate = initialMonth && `${MONTHS[+initialMonth]}/${initialYear}`;
  const finalDate = isCurrent
    ? 'Presente'
    : finalMonth && `${MONTHS[+finalMonth]}/${finalYear}`;
  return (
    <div className="fade alert alert-dark show d-flex flex-column flex-md-row justify-content-between mb-5">
      <div className="flex-grow-1">
        <h5 className="mb-0">{jobPosition}</h5>
        <div className="subheading mb-3">{companyName}</div>
      </div>
      {initialDate && (
        <div className="flex-shrink-0">
          <span className="text-secondary">{`${initialDate} - ${finalDate}`}</span>
        </div>
      )}
    </div>
  );
};

export default XPItem;
